<template>
  <component :is="componentName" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import DefaultHead from './DefaultHead'
import { mapGetters } from 'vuex'

export default {
  components: {
    DefaultHead,
    CitibankHead: () => import(/* webpackChunkName: "citibank-response-table-header" */'@/process/citibank/components/responses/CitiBankTableHead'),
    SchlumCareerHead: () => import(/* webpackChunkName: "schlum-career-response-table-header" */'@/process/schlumberger-career/components/responses/SchlumCareerResponsesHead'),
    SportmasterHead: () => import(/* webpackChunkName: "sportmaster-response-table-header" */'@/process/sportmaster/components/responses/tablehead/SportmasterResponsesHead')
  },
  computed: {
    ...mapGetters('process', ['getProcessName']),

    componentName() {
      switch (this.getProcessName) {
        case 'citibank':
          return 'citibank-head'
          break
        case 'schlum-career':
          return 'schlum-career-head'
          break
        case 'sportmaster':
          return 'sportmaster-head'
          break
        default:
          return 'default-head'
      }
    }
  }
}
</script>
